// src/components/Auth/AuthRoute.js
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { Spinner } from 'react-bootstrap';

/**
 * Komponenta pro ochranu cest, které vyžadují přihlášení
 * Pokud uživatel není přihlášen, přesměruje na přihlašovací stránku
 */
const AuthRoute = ({ children }) => {
    const { user, loading, fetchUser } = useAuthStore();
    const location = useLocation();

    useEffect(() => {
        if (!user && !loading) {
            fetchUser().then(user => {});
        }
    }, [user]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center min-vh-100">
                <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Ověřování přihlášení...</span>
                </Spinner>
            </div>
        );
    }


    if (!user) {
        // Přesměrování na přihlašovací stránku se zapamatováním původní cesty
        //return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }

    return children;
};

export default AuthRoute;